import React from 'react';
import { Row } from 'react-bootstrap';
import useServices from '../../../hooks/useServices';
import Service from '../Service/Service';

const Services = () => {
    const [services] = useServices();
    // console.log(services);
    return (
        <div className='my-5'>
            <h2 className='mb-4'>Service Categories: <span className='text-warning'>{services.length}</span></h2>
            <Row xs={1} md={2} lg={4} className="g-4 mx-2 mx-sm-5 mx-md-5 ms-lg-5">
                {
                    services.map(service => <Service
                        key={service.id}
                        service={service}
                    ></Service>)
                }
            </Row>
        </div>
    );
};

export default Services;